import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { MedicalTravelModel } from "../types/FormTypes";
import { formDataAtom } from "../App";
import { issueAtom } from "./Summary";
import { Box, Heading } from "@ogt/ui";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function OtherUploads() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const [issue] = useAtom(issueAtom);
  const navigate = useNavigate();

  return (
    <div>
      <Formik<MedicalTravelModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("../fler-resor");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
      >
        {({ values }) => (
          <Form>
            <Box fullwidth>
              <Heading headingRef={h2Ref} focusable>
                Tack för din ansökan!
              </Heading>
              <div role="group">
                <p>
                  Vi har tagit emot din ansökan. Ditt ärendenummer är{" "}
                  <strong>{issue?.id ?? ""}</strong>. Uppge det om du kontaktar
                  vår kundservice om det här ärendet.
                </p>
              </div>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
}
